import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import BillingAdminsModalAddUser from 'frontend-payments/components/billing-admins/modal-add-user';
import BillingAdminsTableBillingAdmins from 'frontend-payments/components/billing-admins/table-billing-admins';
import type AuthenticatedBillingAdminsController from 'frontend-payments/controllers/authenticated/billing-admins';
import { contextualPageTitle } from 'frontend-utils';

import styles from './billing-admins.module.css';

interface AuthenticatedBillingAdminsSignature {
  Args: {
    controller: AuthenticatedBillingAdminsController;
  };
}

export default class AuthenticatedBillingAdmins extends Component<AuthenticatedBillingAdminsSignature> {
  @service declare accountSwitcher: Services['account-switcher'];

  <template>
    {{pageTitle
      (contextualPageTitle
        (t "payments.app.header.billing_admins")
        this.accountSwitcher.currentAccount.name
      )
    }}

    <div class={{styles.container}}>
      <section>
        <div class="mb-400 flex items-center justify-between">
          <h2 class="text-emphasis" data-test-billing-admins-title>
            {{t "payments.app.header.billing_admins"}}
          </h2>
          <PrismButton
            @iconBefore="plus"
            @isDisabled={{@controller.isAddUserButtonDisabled}}
            @label={{t "payments.billing_admins.add_user"}}
            @onClick={{@controller.openBillingAdminsModal}}
            data-test-add-user-button
          />
        </div>

        <BillingAdminsTableBillingAdmins
          @billingAdmins={{@controller.billingAdmins}}
          @isBillingAdminsLoading={{@controller.isBillingAdminsLoading}}
          @onEditUser={{@controller.onEditUser}}
          @onRemoveUser={{@controller.onRemoveUser}}
        />
      </section>

      {{#if @controller.showBillingAdminsModal}}
        <BillingAdminsModalAddUser
          @billingAdmin={{@controller.editingBillingAdmin}}
          @billingAdmins={{@controller.billingAdmins}}
          @isEditMode={{@controller.isEditMode}}
          @onCloseModal={{@controller.closeBillingAdminsModal}}
          @onCreateUser={{@controller.createBillingAdminTask}}
          @onEditUser={{@controller.editBillingAdminTask}}
        />
      {{/if}}
    </div>
  </template>
}
